import { gql } from '@apollo/client'

const UPDATE_ALLERGEN_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateAllergenSimpleDetails(
    $id: ID!
    $data: AllergenSimpleDetailsInput!
  ) {
    updateAllergenSimpleDetails(id: $id, data: $data) {
      id
      description
      updatedAt
      updatedBy {
        id
        name
      }
      position
      isExcludedFromSearch
      synonyms
    }
  }
`

export default UPDATE_ALLERGEN_SIMPLE_DETAILS_MUTATION
